import { CalculatorField } from "./fields/calculator";
import { LiveHtmlField } from "./fields/live-html";
import { FormattedNumberField } from "./fields/formatted-number";
import { MirrorField } from "./fields/mirror";
import { LabelMirrorField } from "./fields/label-mirror";
import { DynamicSelectField } from "./fields/dynamic-select";
import { FieldConditions } from "./field-conditions";
import { ConfirmDialog } from "./confirm-dialog";
import { RangeField } from "./fields/range";
import { InternationalPhoneField } from "./fields/international-phone";

const fieldTypes = {
	calculator: CalculatorField,
	"live-html": LiveHtmlField,
	"formatted-number": FormattedNumberField,
	mirror: MirrorField,
	"label-mirror": LabelMirrorField,
	"dynamic-select": DynamicSelectField,
	range: RangeField,
	"international-phone": InternationalPhoneField,
};

const initializedForms = {};

function formHandler(form) {
	const key = form.id;
	if (initializedForms[key]) return;
	initializedForms[key] = true;
	new FieldConditions(form);
	new ConfirmDialog(form);
	// Handle all special fields
	var fields = form.querySelectorAll("[data-dtb-field-type]");
	fields.forEach((field) => {
		const FieldClass = fieldTypes[field.dataset.dtbFieldType];
		if (FieldClass) {
			const fieldInstance = new FieldClass(field, form);
			fieldInstance.init();
		}
	});
}

export const runForm = () => {
	var elements = document.querySelectorAll(".brxe-form");
	elements.forEach(formHandler);
};

export const initializeForms = () => {
	if (bricksIsFrontend) {
		runForm();
	}
	window.bricksForm = runForm;
};
